/* =====================================================================
   MÁQUINA DE PREMIOS · CARRITO Y GUARDIÁN
   ---------------------------------------------------------------------
   Se carga en toda la tienda (snippet coco-maq-guardia). Hace dos cosas:

   1. window.cocoMaquina: funciones que usa la página de la máquina
      para revisar el carrito y reclamar el premio.
   2. El guardián: cada vez que el carrito cambia, revisa que el regalo
      siga cumpliendo las reglas mientras dura la dinámica:
      · solo cuenta el regalo que se agregó desde la máquina;
      · máximo un regalo, cantidad 1;
      · si los productos elegibles bajan de $20, retira el regalo;
      · si se perdió el código y no hay otro, lo vuelve a aplicar.

   La seguridad de verdad la pone el descuento de Shopify (mínimo $20,
   1 por pedido, sin combinar), que el checkout valida siempre.
   Este archivo solo mantiene el carrito ordenado y avisa a la clienta.
   ===================================================================== */
(function () {
  "use strict";
  var M = window.COCO_MAQUINA;
  if (!M || window.cocoMaquina) return;

  var CABECERA = "X-Coco-Maquina";
  var CLAVE_FECHA = "aniv-fecha-simulada"; // la misma que usa la vista previa del aniversario
  var idsPremio = M.premios.map(function (p) { return p.producto; });

  // ---------- fechas ----------
  function vistaPrevia() {
    try { return !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== "main"); } catch (e) { return false; }
  }
  function ahora() {
    if (vistaPrevia() || window.COCO_MAQUINA_DEMO) {
      try {
        var q = new URLSearchParams(location.search).get("fecha");
        if (q && /^\d{4}-\d{2}-\d{2}$/.test(q)) localStorage.setItem(CLAVE_FECHA, JSON.stringify(q));
        var f = JSON.parse(localStorage.getItem(CLAVE_FECHA) || "null");
        if (f) return new Date(f + "T12:00:00" + M.zonaHoraria);
      } catch (e) {}
    }
    return new Date();
  }
  function inicio() { return new Date(M.desde + "T00:00:00" + M.zonaHoraria); }
  function fin() { return new Date(M.hasta + "T23:59:59.999" + M.zonaHoraria); }
  function estado() {
    var t = ahora();
    if (t < inicio()) return "proximo";
    if (t > fin()) return "finalizado";
    return "activo";
  }
  // Antes del 19, en la vista previa, se usa el código de prueba (si existe)
  function codigo() {
    if ((vistaPrevia() || window.COCO_MAQUINA_DEMO) && M.codigoPrueba && new Date() < inicio()) return M.codigoPrueba;
    return M.codigo;
  }

  // ---------- carrito ----------
  function pedir(url, datos) {
    var op = { method: datos ? "POST" : "GET", headers: { Accept: "application/json" }, credentials: "same-origin" };
    op.headers[CABECERA] = "1";
    if (datos) { op.headers["Content-Type"] = "application/json"; op.body = JSON.stringify(datos); }
    return (window.cocoMaquinaFetch || window.fetch).call(window, url, op).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || "Error del carrito"); e.datos = j; throw e; }
        return j;
      });
    });
  }
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var leerCarrito = function () { return pedir(raiz + "cart.js"); };

  var esPremio = function (l) { return idsPremio.indexOf(l.product_id) >= 0; };
  var esDeMaquina = function (l) { return esPremio(l) && l.properties && l.properties[M.marcaLinea]; };
  function premioDe(l) { for (var i = 0; i < M.premios.length; i++) if (M.premios[i].producto === l.product_id) return M.premios[i]; return null; }

  // Suma (en centavos) de lo que cuenta para los $20: todo menos los premios
  function elegibles(c) {
    return c.items.reduce(function (s, l) { return esPremio(l) ? s : s + (l.original_line_price != null ? l.original_line_price : l.line_price); }, 0);
  }
  function resumen(c) {
    var total = elegibles(c), min = Math.round(M.minimo * 100);
    var linea = c.items.filter(esDeMaquina)[0] || null;
    var codigos = (c.discount_codes || []).map(function (d) { return d.code; });
    var nuestro = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === codigo().toUpperCase(); })[0];
    return {
      carrito: c,
      elegibles: total,
      minimo: min,
      falta: Math.max(0, min - total),
      cumple: total >= min,
      linea: linea,
      premioEnCarrito: linea ? premioDe(linea) : null,
      regaloGratis: !!(linea && linea.final_line_price === 0),
      codigoAplicado: !!(nuestro && nuestro.applicable),
      otrosCodigos: codigos.filter(function (k) { return k.toUpperCase() !== codigo().toUpperCase(); }),
    };
  }
  var revisarCarrito = function () { return leerCarrito().then(resumen); };

  function dinero(centavos) {
    var v = (centavos / 100).toFixed(2).replace(".", ",");
    return "$" + v.replace(/,00$/, "");
  }

  // Agrega el premio con la marca oculta y aplica el código del regalo
  function reclamar(idPremio, opciones) {
    opciones = opciones || {};
    var p = M.premios.filter(function (x) { return x.id === idPremio; })[0];
    if (!p) return Promise.reject(new Error("Premio desconocido"));
    if (estado() !== "activo") return Promise.resolve({ ok: false, motivo: "fuera-de-fecha" });
    pausado = true;
    return revisarCarrito()
      .then(function (r) {
        if (!r.cumple) return { ok: false, motivo: "falta", r: r };
        if (r.linea && r.premioEnCarrito && r.premioEnCarrito.id === p.id && r.regaloGratis && (!opciones.talla || (r.linea.properties || {}).Talla === opciones.talla)) return { ok: true, yaEstaba: true, r: r };
        if (r.otrosCodigos.length && !opciones.reemplazarCodigos) return { ok: false, motivo: "otros-codigos", r: r };
        // quita cualquier otro premio que hubiera en el carrito
        var quitar = {};
        r.carrito.items.forEach(function (l) { if (esPremio(l)) quitar[l.key] = 0; });
        var paso = Object.keys(quitar).length ? pedir(raiz + "cart/update.js", { updates: quitar }) : Promise.resolve();
        var props = {};
        props[M.marcaLinea] = "1";
        props["Regalo"] = "Máquina de premios ♡";
        if (opciones.talla) props["Talla"] = opciones.talla;
        return paso
          .then(function () { return pedir(raiz + "cart/add.js", { items: [{ id: p.variante, quantity: 1, properties: props }] }); })
          .then(function () { return pedir(raiz + "cart/update.js", { discount: codigo() }); })
          .then(revisarCarrito)
          .then(function (r2) {
            if (r2.regaloGratis) return { ok: true, r: r2 };
            // El descuento no se aplicó: no dejamos el premio cobrándose sin avisar
            var u = {};
            if (r2.linea) u[r2.linea.key] = 0;
            return (r2.linea ? pedir(raiz + "cart/update.js", { updates: u }) : Promise.resolve())
              .catch(function () {})
              .then(revisarCarrito)
              .then(function (r3) { return { ok: false, motivo: "sin-descuento", r: r3 }; });
          });
      })
      .catch(function (e) {
        var m = (e && e.datos && (e.datos.description || e.datos.message)) || "";
        return { ok: false, motivo: /agotad|sold out|disponible|available|stock/i.test(m) ? "agotado" : "error", mensaje: m };
      })
      .then(function (res) { pausado = false; actualizarIcono(); return res; });
  }

  // ---------- disponibilidad de los premios ----------
  function disponibilidad() {
    return Promise.all(M.premios.map(function (p) {
      return pedir(raiz + "products/" + encodeURIComponent(p.handle) + ".js")
        .then(function (j) { return { id: p.id, disponible: !!j.available, imagen: j.featured_image || p.imagen }; })
        .catch(function () { return { id: p.id, disponible: true, imagen: p.imagen }; });
    }));
  }

  // ---------- icono del carrito (nube del menú Coco Rosa y, si existe, el de Dawn) ----------
  function actualizarIcono() {
    leerCarrito().then(function (c) {
      document.querySelectorAll('.coco .cloud-btn[href$="/cart"]').forEach(function (a) {
        var n = a.querySelector(".cart-count");
        if (!c.item_count) { if (n) n.remove(); }
        else {
          if (!n) { n = document.createElement("span"); n.className = "cart-count"; (a.querySelector(".cloud-shape") || a).appendChild(n); }
          n.textContent = c.item_count;
        }
        a.setAttribute("aria-label", "Ver carrito (" + c.item_count + ")");
      });
    }).catch(function () {});
    var burbuja = document.getElementById("cart-icon-bubble");
    if (!burbuja) return;
    (window.cocoMaquinaFetch || window.fetch).call(window, raiz + "?sections=cart-icon-bubble", { headers: (function () { var h = {}; h[CABECERA] = "1"; return h; })() })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s["cart-icon-bubble"];
        if (!html) return;
        var d = new DOMParser().parseFromString(html, "text/html").querySelector(".shopify-section");
        if (d) burbuja.innerHTML = d.innerHTML;
      })
      .catch(function () {});
  }

  // ---------- aviso flotante (fuera de la página de la máquina) ----------
  function aviso(texto) {
    if (window.cocoMaquinaAviso) return window.cocoMaquinaAviso(texto);
    var a = document.getElementById("coco-maq-aviso");
    if (!a) {
      a = document.createElement("div");
      a.id = "coco-maq-aviso";
      a.setAttribute("role", "status");
      a.style.cssText = "position:fixed;left:50%;bottom:18px;z-index:2147483000;transform:translate(-50%,24px);max-width:min(92vw,440px);padding:12px 18px;border-radius:18px;background:#4B3527;color:#F9F4DF;font:600 16px/1.35 'EB Garamond',Garamond,serif;text-align:center;box-shadow:0 14px 30px -12px rgba(75,53,39,.6);opacity:0;transition:opacity .3s,transform .4s cubic-bezier(.34,1.56,.64,1);pointer-events:none";
      document.body.appendChild(a);
    }
    a.textContent = texto;
    requestAnimationFrame(function () { a.style.opacity = "1"; a.style.transform = "translate(-50%,0)"; });
    clearTimeout(a._t);
    a._t = setTimeout(function () { a.style.opacity = "0"; a.style.transform = "translate(-50%,24px)"; }, 6000);
  }

  // ---------- GUARDIÁN ----------
  var pausado = false, revisando = false, otraVez = false, avisoCodigos = false;
  function guardian() {
    if (pausado || estado() !== "activo") return Promise.resolve();
    if (revisando) { otraVez = true; return Promise.resolve(); }
    revisando = true;
    return leerCarrito()
      .then(function (c) {
        var cambios = {}, motivo = null, hay = false;
        var premios = c.items.filter(esPremio);
        var guardado = null;
        premios.forEach(function (l) {
          if (!esDeMaquina(l)) { cambios[l.key] = 0; hay = true; motivo = motivo || "fuera"; return; }
          if (!guardado) { guardado = l; if (l.quantity > 1) { cambios[l.key] = 1; hay = true; motivo = motivo || "uno"; } return; }
          cambios[l.key] = 0; hay = true; motivo = motivo || "uno";
        });
        if (guardado && elegibles(c) < Math.round(M.minimo * 100)) { cambios[guardado.key] = 0; hay = true; motivo = "minimo"; guardado = null; }
        var paso = hay ? pedir(raiz + "cart/update.js", { updates: cambios }) : Promise.resolve(null);
        return paso.then(function () {
          if (!guardado) return hay;
          var codigos = (c.discount_codes || []).map(function (d) { return d.code.toUpperCase(); });
          if (codigos.indexOf(codigo().toUpperCase()) >= 0) return hay;
          if (!codigos.length) return pedir(raiz + "cart/update.js", { discount: codigo() }).then(function () { return true; });
          if (!avisoCodigos) { avisoCodigos = true; aviso("Tu regalo de la Máquina de premios es gratis solo sin otros códigos de descuento ♡"); }
          return hay;
        }).then(function (cambio) {
          if (motivo === "minimo") aviso("Retiramos tu regalo porque tus productos bajaron de " + dinero(Math.round(M.minimo * 100)) + ". Tu premio sigue guardado en la máquina ♡");
          else if (motivo === "fuera") aviso("Los premios sorpresa solo se obtienen en la Máquina de premios ♡");
          else if (motivo === "uno") aviso("La Máquina de premios regala una sola joyita por pedido ♡");
          if (cambio) refrescar();
        });
      })
      .catch(function () {})
      .then(function () { revisando = false; if (otraVez) { otraVez = false; guardian(); } });
  }
  function refrescar() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var cajon = document.querySelector("cart-drawer");
    if (cajon && cajon.classList.contains("active")) { location.reload(); return; }
    actualizarIcono();
    document.dispatchEvent(new CustomEvent("coco-maquina:carrito"));
  }

  // Escucha los cambios del carrito que hace el tema (fetch a /cart/...)
  var fetchOriginal = window.fetch;
  window.cocoMaquinaFetch = fetchOriginal;
  var temporizador = null;
  window.fetch = function (recurso, op) {
    var url = typeof recurso === "string" ? recurso : (recurso && recurso.url) || "";
    var nuestro = false;
    try {
      var h = (op && op.headers) || (recurso && recurso.headers);
      nuestro = !!(h && (h[CABECERA] || (h.get && h.get(CABECERA))));
    } catch (e) {}
    var p = fetchOriginal.apply(this, arguments);
    if (!nuestro && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { clearTimeout(temporizador); temporizador = setTimeout(guardian, 350); }, function () {});
    }
    return p;
  };
  window.addEventListener("pageshow", function () { setTimeout(guardian, 600); });

  window.cocoMaquina = {
    config: M,
    estado: estado,
    ahora: ahora,
    inicio: inicio,
    fin: fin,
    vistaPrevia: vistaPrevia,
    codigo: codigo,
    revisarCarrito: revisarCarrito,
    reclamar: reclamar,
    disponibilidad: disponibilidad,
    dinero: dinero,
    guardian: guardian,
    actualizarIcono: actualizarIcono,
  };
})();
